'use client';

import { SessionProvider } from 'next-auth/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from './PostHogProvider';
import { createContext, useState } from 'react';
import { PlatformEnum } from '@/server/utils/platform-enum';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export default function Providers(props: { children: React.ReactNode }) {
  return (
    <PostHogProvider>
      <SessionProvider>
        <AppStateProvider>
          <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
        </AppStateProvider>
      </SessionProvider>
    </PostHogProvider>
  );
}

export const AppStateContext = createContext<{
  platformFilter: PlatformEnum;
  setPlatformFilter: (platform: PlatformEnum) => void;
}>({
  platformFilter: PlatformEnum.TikTok,
  setPlatformFilter: () => {},
});

export function AppStateProvider({ children }: { children: React.ReactNode }) {
  const [platformFilter, setPlatformFilter] = useState<PlatformEnum>(PlatformEnum.TikTok);

  return (
    <AppStateContext.Provider value={{ platformFilter, setPlatformFilter }}>
      {children}
    </AppStateContext.Provider>
  );
}
